<template>
  <section class="option-menu">
    <div class="title-holder">
      <span class="title">{{ options.title }}</span>
    </div>
    <div class="buttons-holder">
      <button
        v-for="(value, propertyName) in options.values"
        class="color-button"
        :class="{ active: value.name === activeColor }"
        :style="{ 'background-color': value.color }"
        :key="propertyName"
        @click="
          setColor(options.title, value.name, options.property, propertyName)
        "
      ></button>
    </div>
    <!--  <div class="cmyk-menu">
      <span>C:<input type="text" v-model="c" @input="setCMYK(c)" />%</span>
      <span>M:<input type="text" v-model="m" @input="setCMYK(m)" />%</span>
      <span>Y:<input type="text" v-model="y" @input="setCMYK(y)" />% </span>
      <span>K:<input @input="setCMYK(k)" v-model="k" type="text" />%</span>
    </div> -->
  </section>
</template>

<script>
export default {
  props: ['options', 'active'],
  data() {
    return {
      prevTimeOut: null,
      c: undefined,
      m: undefined,
      y: undefined,
      k: undefined,
      activeColor: ''
    }
  },
  methods: {
    setColor(title, name, prop, propName) {
      this.$emit('set-color', title, name, prop, propName)
      this.activeColor = name
    },
    setCMYK(color) {
      if (this.prevTimeOut) {
        clearTimeout(this.prevTimeOut)
      }

      if (this.c && this.m && this.y && this.k) {
        this.prevTimeOut = setTimeout(() => {
          //     this.$emit('set-custom-field', [id, val])

          this.$emit(
            'set-color',
            '',
            this.c / 100 +
              ' ' +
              this.m / 100 +
              ' ' +
              this.y / 100 +
              ' ' +
              this.k / 100,
            this.options.property,
            'cmyk'
          )
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  float: none;
}
.cmyk-menu {
  span {
    display: inline-block;
  }
  input {
    border-radius: 17px;
    height: 34px;
    padding: 0 10px;
    border: 1px solid #ececec;
    transition: border-color 0.25s;
    width: 45px;
  }
}
.option-menu {
  padding: 0;
}

.buttons-holder {
  margin-bottom: 15px;
}

.title-holder {
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  button {
    margin-left: 8px;
  }
}

span {
  font-weight: 500;
}

.color-button {
  width: 28px;
  height: 28px;
  border-radius: 14px;
  margin-right: 7px;
  vertical-align: middle;
  box-shadow: rgba(0, 0, 0, 0.4) 0 0 9px -4px;

  &.active {
    border: 2px solid white;
    box-shadow: var(--sub-color) 0 0 0 2px;
  }
}
</style>
